import { TYPE } from "@8x8/oxygen-toaster";
import { differenceInDays } from "date-fns";

export const UNSELECTED_START_DATE = Object.freeze({
  type: TYPE.warning,
  content: "Start date must be defined",
});

export const UNSELECTED_END_DATE = Object.freeze({
  type: TYPE.warning,
  content: "End date must be defined",
});

export const WRONG_DATES_ORDER = Object.freeze({
  type: TYPE.warning,
  content: "Start date must come before end date",
});

export const MAX_ALLOWED_DIFFERENCE_EXCEEDED = Object.freeze({
  type: TYPE.warning,
  content: "Difference between start date and end date cannot exceed 31 days",
});

export const validateAuditDateRange = (startDateInput, endDateInput) => {
  if (!startDateInput) {
    return UNSELECTED_START_DATE;
  }
  if (!endDateInput) {
    return UNSELECTED_END_DATE;
  }

  const startDate = getDateFromOxygenSelector(startDateInput);
  const endDate = getDateFromOxygenSelector(endDateInput);
  if (startDate > endDate) {
    return WRONG_DATES_ORDER;
  }
  if (differenceInDays(endDate, startDate) >= 31) {
    return MAX_ALLOWED_DIFFERENCE_EXCEEDED;
  }
  return true;
};

export const getDateFromOxygenSelector = (oxygenDateTimeSelectorDate) =>
  new Date(oxygenDateTimeSelectorDate);
